import * as bootstrap from 'bootstrap';
import jsKit from './jsKit';
import basketPlugins from '../../../shared/modules/basketPlugins';

const basket = (() => {
  const defaults = {
    debugMode: false,
  };

  return {
    reloadDeliveryOptions: async () => {
      if (defaults.debugMode) {
        console.log('reloadDeliveryOptions()');
      }

      const url = '/basket/reloadDeliveryOptions/';

      try {
        const response = await fetch(url);
        const data = await response.json();
        if (data.validated) {
          document.querySelector('#delivery-options').innerHTML = data.delivery_options;
          document.querySelector('#payment-options').innerHTML = data.payment_options;
          document.querySelector('#basket-teaser').innerHTML = data.basket_summary;
          await basketPlugins.showDeliveryOptionPanel(null, true);
        }
      } catch (error) {
        console.log('Wystąpił błąd: ', error);
      }
    },

    setDeliveryOption: async (e) => {
      const optionId = e.target.dataset.jsSetDeliveryOption;
      const ctoken = document.querySelector('[name="basket_delivery_payment_form[ctoken]"]').value;
      if (defaults.debugMode) {
        console.log(`setDeliveryOption(${optionId})`);
      }
      e.preventDefault();

      const url = '/basket/setDeliveryOption/';
      const formData = new FormData();
      formData.append('basket_delivery_option_form[delivery_option]', optionId);
      formData.append('basket_delivery_option_form[ctoken]', ctoken);

      try {
        const response = await fetch(url, {
          method: 'POST',
          body: formData,
        });

        const data = await response.json();
        if (data.validated) {
          document.querySelector('#delivery-options').innerHTML = data.delivery_options;
          await basketPlugins.showDeliveryOptionPanel(null, true);

          document.querySelector('#payment-options').innerHTML = data.payment_options;
          await basketPlugins.showPaymentOptionPanel();

          document.querySelector('#basket-teaser').innerHTML = data.basket_summary;
        } else {
          jsKit.showErrors(data, '#basket_delivery_payment_form');
        }
      } catch (error) {
        console.log('Wystąpił błąd: ', error);
      }
    },

    basketSummary: async () => {
      await basket.updateBasketDeliveryAndPayment('/wizard/step7');
    },

    reloadBasketContentStep2: async () => {
      const url = '/basket/loadBasketContentStep2';
      if (defaults.debugMode) {
        console.log(`reloadBasketContentStep2(${url})`);
      }
      const getCB = (data) => {
        for (const selector in data) {
          document.querySelector(`#${selector}`).innerHTML = data[selector];
        }
      };
      await jsKit.fetchUrl(url, getCB);
    },

    updateBasketDeliveryAndPayment: async (nextStepUrl = '') => {
      if (defaults.debugMode) {
        console.log(`updateBasketDeliveryAndPayment(${nextStepUrl})`);
      }
      const url = `/basket/updateDeliveryAndPayment/${nextStepUrl}`;
      const form = document.querySelector('#basket_delivery_payment_form');
      const paymentOptions = document.querySelector('#payment-options');
      const deliveryOptions = document.querySelector('#delivery-options');
      paymentOptions.querySelectorAll('input').forEach((input) => {input.disabled = true});
      deliveryOptions.querySelectorAll('input').forEach((input) => {input.disabled = true});


      const getCB = (data) => {
        if (data) {
          paymentOptions.querySelectorAll('input').forEach((input) => {input.disabled = false});
          deliveryOptions.querySelectorAll('input').forEach((input) => {input.disabled = false});

          if (data.validated) {
            if (nextStepUrl) {
              document.location = nextStepUrl;
              return;
            }
            basket.reloadBasketContentStep2();
          } else if (nextStepUrl) {
            jsKit.showErrors(data, '#basket_delivery_payment_form');
          }
        }
      };

      await jsKit.fetchUrl(url, getCB, 'json', 'POST', new FormData(form))
    },

    setPaymentOption: async (e) => {
      const optionId = e.target.dataset.jsSetPaymentOption;
      const ctoken = document.querySelector('[name="basket_delivery_payment_form[ctoken]"]').value;
      if (defaults.debugMode) {
        console.log(`setPaymentOption(${optionId})`);
      }
      e.preventDefault();

      const url = '/basket/setPaymentOption/';
      const formData = new FormData();
      formData.append('basket_payment_option_form[payment_option]', optionId);
      formData.append('basket_payment_option_form[ctoken]', ctoken);

      try {
        const response = await fetch(url, {
          method: 'POST',
          body: formData,
        });

        const data = await response.json();
        if (data.validated) {
          document.querySelector('#delivery-options').innerHTML = data.delivery_options;
          await basketPlugins.showDeliveryOptionPanel(null, true);

          document.querySelector('#payment-options').innerHTML = data.payment_options;
          await basketPlugins.showPaymentOptionPanel();

          document.querySelector('#basket-teaser').innerHTML = data.basket_summary;
        } else {
          jsKit.showErrors(data, '#basket_payment_option_form');
        }
      } catch (error) {
        console.log('Wystąpił błąd: ', error);
      }
    },

    changeDeliveryCountry: async (e) => {
      const countryId = e.target.value;
      if (defaults.debugMode) {
        console.log(`changeDeliveryCountry(${countryId})`);
      }
      e.preventDefault();

      if (countryId) {
        const url = `/basket/changeDeliveryCountry/${countryId}`;
        const getCB = (data) => {
          if (data.validated) {
            document.querySelector('#delivery-options').innerHTML = data.delivery_options;
            document.querySelector('#payment-options').innerHTML = data.payment_options;
            document.querySelector('#basket-teaser').innerHTML = data.basket_summary;
          }
        };
        await jsKit.fetchUrl(url, getCB);
      }
    },

    toggleInvoiceData: (e) => {
      const paymentDataCollapse = new bootstrap.Collapse('#payment-data');
      if (e.target.checked) {
        e.target.closest('[data-checkbox-toggle]').classList.remove('collapsed');
        paymentDataCollapse.show();
      } else {
        e.target.closest('[data-checkbox-toggle]').classList.add('collapsed');
        paymentDataCollapse.hide();
      }
    },

    copyDeliveryDataToInvoiceData: (e) => {
      if (defaults.debugMode) {
        console.log('copyDeliveryDataToInvoiceData()');
      }
      const fields = ['full_name', 'street_name', 'building_number', 'apartment_number', 'postal_code', 'city', 'country_id'];

      fields.forEach((field) => {
        document.querySelector(`#invoice_${field}`).value = document.querySelector(`#delivery_${field}`).value;
      });
    },

    createOrderKitman: async (e) => {
      if (defaults.debugMode) {
        console.log('createOrderKitman()');
      }
      e.preventDefault();
      e.target.disabled = true;
      e.target.classList.add('loading');
      const url = '/basket/createOrder';

      try {
        const response = await fetch(url, {
          method: 'POST',
        });

        const data = await response.json();
        if (data) {
          e.target.disabled = false;
          e.target.classList.remove('loading');

          if (data.validated) {
            document.location = data.kitman_location;
          } else {
            jsKit.showErrors(data, 'body');
          }

          if (data.load_flash_message) {
            jsKit.loadFlashMessages(data.load_flash_message);
          }
        }
      } catch (error) {
        console.log('Wystąpił błąd: ', error);
      }
    },

  };
})();

export default basket;
